import { combineReducers } from 'redux';
import UsersReducers from './UsersReducers';
import Developer_Reducer from './DevelopersReducer';
import ProjectsReducers from './Projects_Reducer';
import city_Reducer from './CityReducer';
import Sales_Reducers from './Sales_reducers';
import Auth_Reducer from './AuthReducer';
import ActionReducers from './ActionReducers';
import Channal_Reducer from './Channal_Reducer';
import Region_Reducer from './RegionsReducers';
import Area_Reducer from './AreaReducers';
import Communicationway_Reducer from './CommunicationWay_Reducer';
import StageType_Reducer from './StageType_Reducers';
import Stages_Reducer from './Stages_Reducers';
import Cancelreason_Reducer from './CancelReason_Reducer';
import user_Activation_Reducer from './user_activation_reducers';
import { Lead_Assigned_Reducers } from './Lead_Assigned_Reducers';
import { Lead_Stages_Changed_Reducers } from './Leads_Stages_Reducers';
import Campaign_Reducer from './Campaign_Reducers';
import Rotation_Reducer from './Rotation_Reducer';
import DataForRoles_Reducers from './DataForRoles_Reducers';
import SalesPerformanceReduce from './SalesPerformanceReduce';
import Marketing_Reports_Reducer from './Marketing_Reports_Reducer';
import Accountant_Reducer from './Accountant_Reducer';
import Commission_Reducer from './Commission_Reducer';
import Schedual_Commission_Dates_Reducer from './Schedual_Commission_Dates_Reducer';
import Commission_Pay_Reducer from './Commission_Pay_Reducer';
import Accountant_Task_Reducer from './Accountant_Task_Reducer';
import Company_Profile_Reducer from './Company_Profile_Reducer';
import Users_Tasks_Reducer from './Users_Tasks_Reducer';
import Devices_reducers from './Devices_reducers';
import AllLeadsForAdminReducer from './AllLeadsForAdminReducer';
import CRMDataCenter_reducer from './CRMDataCenter_reducer';
import { MeetingCommentsReducer } from './MeetingCommentsReducer';

export default combineReducers({
  Allusers: UsersReducers,
  AllDevelopers: Developer_Reducer,
  AllCities: city_Reducer,
  AllProjects: ProjectsReducers,
  AllSales: Sales_Reducers,
  AuthRoot: Auth_Reducer,
  AllActions: ActionReducers,
  AllChannalRoot: Channal_Reducer,
  AllRegions: Region_Reducer,
  AllArea: Area_Reducer,
  AllCommunicationway: Communicationway_Reducer,
  AllStagetype: StageType_Reducer,
  Allstages: Stages_Reducer,
  AllCancelReasons: Cancelreason_Reducer,
  AllUserActivation: user_Activation_Reducer,
  AllLead_Assigned: Lead_Assigned_Reducers,
  AllLeads_Stages_Changed: Lead_Stages_Changed_Reducers,
  AllCampaign: Campaign_Reducer,
  AllRotation: Rotation_Reducer,
  AllRoleData: DataForRoles_Reducers,
  AllSalesPerformance: SalesPerformanceReduce,
  AllMarketingReports: Marketing_Reports_Reducer,
  AllAcountant_Reducer: Accountant_Reducer,
  AllCommissions: Commission_Reducer,
  AllSchedual_Commission_Dates: Schedual_Commission_Dates_Reducer,
  AllCommission_Pays: Commission_Pay_Reducer,
  AllTasks_Reducer: Accountant_Task_Reducer,
  AllCompanyProfile: Company_Profile_Reducer,
  AllUsrsTasks: Users_Tasks_Reducer,
  All_Users_Devices: Devices_reducers,
  All_Leads_For_Admin_Reducer: AllLeadsForAdminReducer,
  All_CrmDataCenter_Reducer: CRMDataCenter_reducer,
  AllMeetingComments: MeetingCommentsReducer,
});
